import { render, staticRenderFns } from "./StaffTabs.vue?vue&type=template&id=de3798dc&"
import script from "./StaffTabs.vue?vue&type=script&lang=js&"
export * from "./StaffTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports